import ArrowTopRight from '@/assets/icons/arrow-up-right.svg?react';
import ArrowDownRight from '@/assets/icons/arrow-down-right.svg?react';
import { InsightOverallSatisfaction } from '@/services/dashboard-service/dashboard.service.types';
import InsightCard from '../insights-card/insights-card';
import { AverageCSATScoreTitles, InsightsTitles } from '@/constants/insights.constants';
import styles from './average-csat-score.module.scss';
import { Flex } from 'antd';
import Icon from '@ant-design/icons';
import { NoRecords } from '@/components/no-records/no-records';
import { getArrowColor } from './average-csat-score.utils';
import { tooltips } from '../insights-cards-wrapper/insights-cards-wrapper.utils';

interface AverageCSATScoreProps {
  isLoading?: boolean;
  overallSatisfactionData?: InsightOverallSatisfaction;
}

export default function AverageCSATScore({
  isLoading,
  overallSatisfactionData,
}: AverageCSATScoreProps) {
  const hideScore =
    (overallSatisfactionData && Object.values(overallSatisfactionData).every((value) => !value)) ||
    !overallSatisfactionData;

  const { change, overall } = overallSatisfactionData
    ? overallSatisfactionData
    : { change: undefined, overall: undefined };
  const isPositive = change ? change > 0 : false;
  const arrowIcon = isPositive ? (
    <Icon component={() => <ArrowTopRight width="20" height="20" />} />
  ) : (
    <Icon component={() => <ArrowDownRight width="20" height="20" />} />
  );

  const hideChange =
    overallSatisfactionData?.ai === 0 &&
    overallSatisfactionData?.agent === 0 &&
    overallSatisfactionData.responses === 0;

  return (
    <InsightCard
      tooltip={tooltips.csatScore}
      title={InsightsTitles.AVERAGE_SATISFACTION}
      isLoading={isLoading || !overallSatisfactionData}
    >
      {!hideScore ? (
        <Flex justify="space-around" wrap="wrap">
          <Flex vertical align="center" style={{ padding: '12px', alignItems: 'center' }}>
            <span className={styles.header}>{AverageCSATScoreTitles.OVERALL_SATISFACTION}</span>
            <Flex className={styles.satisfactionContainer} gap={8}>
              <Flex className={styles.satisfactionPercentage} gap={2}>
                <span>{overall}</span>
                <span className={styles.satisfactionPercentageMark}>%</span>
                {!hideChange && change !== undefined && (
                  <div
                    className={styles.satisfactionPercentageChange}
                    style={{ color: getArrowColor(change) }}
                  >
                    {arrowIcon}
                    <span>{`${change}%`}</span>
                  </div>
                )}
              </Flex>
              <Flex
                className={styles.satisfactionResponses}
              >{`(${overallSatisfactionData.responses} responses)`}</Flex>
            </Flex>
          </Flex>
          {/* 
          <Flex vertical style={{ padding: '12px', alignItems: 'center' }}>
            <span className={styles.header}>{AverageCSATScoreTitles.RESOLUTION_RATE}</span>
            <Flex className={styles.csatContainer}>
              <Flex vertical align="center" justify="flex-end" style={{ height: '100%' }}>
                <div
                  className={styles.aiBar}
                  style={{
                    height: `${overallSatisfactionData.ai}%`,
                  }}
                >
                  <span
                    className={clsx(
                      styles.labelLeft,
                      Number(overallSatisfactionData.ai) < 15 && styles['labelLeft-dark']
                    )}
                  >{`${overallSatisfactionData.ai}%`}</span>
                </div>
                <span className={styles.label}>Ai</span>
              </Flex>
              <Flex vertical align="center" justify="flex-end" style={{ height: '100%' }}>
                <div
                  className={styles.agentBar}
                  style={{
                    height: `${overallSatisfactionData.agent}%`,
                  }}
                >
                  <span
                    className={clsx(
                      styles.labelRight,
                      Number(overallSatisfactionData.agent) < 15 && styles['labelRight-dark']
                    )}
                  >{`${overallSatisfactionData.agent}%`}</span>
                </div>
                <span className={styles.label}>Agent</span>
              </Flex>
            </Flex>
          </Flex> */}
        </Flex>
      ) : (
        <NoRecords />
      )}
    </InsightCard>
  );
}
